<template>
    <transition name="fade">
        <div v-if="isActive" class="store-window" @click="$emit('close')">
            <div @click.stop class="store-window__content">
                <div :class="{ 'store-window__content__store': true, active: false }">
                    <!-- ITEM BTN -->
                    <div type="button" class="store-window__content__store__btn">
                        <svg class="store-window__content__store__btn__icon --store">
                            <use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#marketIcon"></use>
                        </svg>
                        <div class="store-window__content__store__btn__info">
                            <h4>{{ activeStore.city }}</h4>
                            <span>{{ activeStore.address }}</span>
                        </div>
                    </div>
                    <!-- ITEM CONTENT -->
                    <div class="store-window__content__store__content">
                        <a
                            class="store-window__content__store__content__path"
                            target="_blank"
                            :href="pathToStoreLocation(activeStore.coordinates.lng, activeStore.coordinates.lat)"
                        >
                            <span>{{ $t('storesLocationsTextAttributePath') }}</span>
                            <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowCornerIcon"></use></svg>
                        </a>

                        <div class="store-window__content__store__content__info">
                            <div class="store-window__content__store__content__info__item">
                                <small>{{ $t('storesLocationsTextAttributeSchedule') }}</small>
                                <span v-for="(time, idx) in activeStore.schedule" :key="idx">{{ time }}</span>
                            </div>
                            <div class="store-window__content__store__content__info__item">
                                <small>{{ $t('storesLocationsTextAttributeContacts') }}</small>
                                <a v-for="(time, idx) in activeStore.phones" :key="idx" :href="`tel:${time}`">{{ time }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <Map
                    class="store-window__content__map"
                    :stores="stores"
                    :activeStore="activeStore"
                    :iconStoreActive="iconStoreActive"
                    :iconStoreDisabled="iconStoreDisabled"
                />
                <button type="button" class="store-window__content__close-btn" @click="$emit('close')">
                    <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#closeIcon"></use></svg>
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';
import { StoreItem } from '../../types';

export default {
    name: 'StoreWindow',
    props: {
        isActive: VueTypes.bool.def(false),
        stores: VueTypes.arrayOf(StoreItem).isRequired,
        iconStoreActive: VueTypes.oneOfType([String, nullable]).isRequired,
        iconStoreDisabled: VueTypes.oneOfType([String, nullable]).isRequired,
        activeStore: VueTypes.oneOfType([StoreItem, nullable]).def(null)
    },
    components: {
        Map: () => import('./../Map')
    },
    methods: {
        pathToStoreLocation(longitude, latitude) {
            return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './../../styles/context';
@import './styles.scss';
</style>
